import { useNavigate } from "react-router-dom";

const DeveloperTools = () => {
  const navigate = useNavigate();

  const tools = [
    {
      key: "/convert-jpg-to-png",
      title: "Image Converter",
      description:
        "Convert images between different formats like PNG to JPG, WEBP to PNG, and more. Fast, reliable, and maintains quality.",
      icon: require("../../assets/conversion.png"),
      color: "primary",
    },
    {
      key: "placeholder-image-generator",
      title: "Placeholder Image Generator",
      description:
        "Generate custom placeholder images for your projects. Choose dimensions, colors, and text to create perfect mockup images.",
      icon: require("../../assets/default-image.png"),
      color: "primary",
    },
    {
      key: "json-generator",
      title: "Advanced Json Generator",
      description:
        "Create custom JSON schemas. Use predefined templates with ready-to-use structures. Generate realistic fake data for testing and development.",
      icon: require("../../assets/fake-json.png"),
      color: "danger",
    },
    // {
    //   title: "JSON Viewer",
    //   description:
    //     "View, format, and validate JSON data. Pretty-print messy JSON, check syntax errors, and explore nested structures easily.",
    //   icon: "📋",
    //   color: "warning",
    // },
    // {
    //   title: "Color Palette Generator",
    //   description:
    //     "Create beautiful color palettes for your designs. Generate harmonious color schemes, gradients, and export in various formats.",
    //   icon: "🎨",
    //   color: "info",
    // },
    // {
    //   title: "QR Code Generator",
    //   description:
    //     "Generate QR codes for URLs, text, contact info, and more. Customize size, error correction, and download in high quality.",
    //   icon: "📱",
    //   color: "dark",
    // },
    // {
    //   title: "Base64 Encoder/Decoder",
    //   description:
    //     "Encode and decode Base64 strings for data URIs, API integrations, and file handling. Supports text and binary data.",
    //   icon: "🔐",
    //   color: "success",
    // },
    // {
    //   title: "CSS Minifier",
    //   description:
    //     "Minify and optimize CSS code to reduce file size and improve loading speed. Remove comments, whitespace, and redundancy.",
    //   icon: "🎯",
    //   color: "secondary",
    // },
  ];

  return (
    <section>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-6 fw-bold mb-3">Developer Tools</h2>
          <h3 className="text-body-secondary fw-normal fs-4">
            Essential utilities for developers and designers.
          </h3>
          <h3 className="text-body-secondary fw-normal fs-4">
            Convert, compress, generate, and optimize your digital assets with
            our collection of professional tools.
          </h3>
        </div>
        <div className="container py-2">
          {/* Tools Grid */}
          <div className="row g-4">
            {tools.map((tool, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="category-card h-100 p-4 text-center rounded">
                  <div
                    className="hero-gradient d-inline-flex align-items-center  justify-content-center bg-light rounded mb-3"
                    style={{ width: "64px", height: "64px" }}
                  >
                    <img
                      alt="tool-icon"
                      width={50}
                      height={50}
                      src={tool.icon}
                    />
                  </div>
                  <h3 className="fw-bold fs-4">{tool.title}</h3>
                  <p className="text-body-secondary fw-medium flex-grow-1">
                    {tool.description}
                  </p>
                  <button
                    onClick={() => {
                      setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }, 100);
                      navigate(tool.key);
                    }}
                    className="btn hero-gradient fw-bold text-white mt-3 align-self-end"
                  >
                    Use Tool →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeveloperTools;
